/* eslint-disable @typescript-eslint/restrict-template-expressions */
import React, { useRef } from "react";

type TooltipProps = {
  children: React.ReactNode;
  text: string;
  classes?: Partial<{
    container: string;
    tooltip: string;
  }>;
  position?: {
    top?: string;
    left?: string;
    bottom?: string;
    right?: string;
  };
};

export const Tooltip = ({
  children,
  text,
  classes = {},
  position = {},
}: TooltipProps): React.ReactElement => {
  const spanRef = useRef<HTMLSpanElement>(null);

  const { top, left } = spanRef.current?.getBoundingClientRect() ?? {};

  const tooltipStyles = position
    ? { ...position }
    : {
        top: `${top}px`,
        left: `${left}px`,
      };

  return (
    <span
      ref={spanRef}
      className={`group/tooltip  ${classes?.container ?? ""}`}
    >
      {children}
      {text ? (
        <span
          style={tooltipStyles}
          className={`absolute z-[1000] hidden whitespace-nowrap rounded-[5px] border-[1px] border-[#D6D6D6] bg-[#FFFFFF] px-[16px] py-[8px] text-[10px] font-[500] text-[#484848] shadow-[2px_2px_2px_rgba(0,0,0,0.15)] group-hover/tooltip:block ${
            classes.tooltip ?? ""
          }`}
        >
          {text}
        </span>
      ) : null}
    </span>
  );
};
